// extracted by mini-css-extract-plugin
module.exports = {"eastvalePageWrapper":"style_eastvalePageWrapper___AAXd","eastvalePageBlock":"style_eastvalePageBlock__0p8SQ","eastvalePageSoon":"style_eastvalePageSoon__iLit1"};